<template>

    <div class="contact-page">
        <Header></Header>
        <section class="contact-section" style="padding: 150px 0 50px;">
            <div class="container">
                <div class="row">
                    <div class="col-md-5" style="margin: 0 auto;">
                        <h2>Contact Us</h2>
                        <form class="form" v-on:submit="contactFormSubmit">
                            <div class="input-field form-input">
                                <label for="your-name">Your Name *</label>
                                <input type="text" placeholder="Full Name" v-model="name" id="your-name" v-on:blur="nameFuntion(name)">
                                <p class="error-input" v-if="nameFlag">Name is required</p>
                            </div>
                            <div class="input-field form-input">
                                <label for="your-email">Your Email *</label>
                                <input type="text" placeholder="johndoe@email.com" v-model="email" id="your-email" v-on:blur="emailFuntion(email)">
                                <p class="error-input" v-if="emailFlag">Email is required</p>
                            </div>
                            <div class="input-textarea-field form-input">
                                <label for="your-message">Message *</label>
                                <textarea placeholder="Your Message..." id="your-message" v-model="message" v-on:blur="messageFuntion(message)"></textarea>
                                <p class="error-input" v-if="messageFlag">Message is required</p>
                            </div>

                            <div class="input-submit">
                                <button type="submit" v-if="submitOnce">SUBMIT</button>
                                <a href="javascript:void(0)" v-if="!submitOnce">SUBMIT...</a>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from './Header'
    import Footer from './Footer'
    import axios from 'axios'
    import Vue from 'vue'
    import VueToast from 'vue-toast-notification'
    import 'vue-toast-notification/dist/index.css'
    Vue.use(VueToast)
    export default {
        name: 'Contact',
        components: {
            'Header': Header,
            'Footer': Footer
        },
        data() {
            return {
                msg: 'Welcome to Your Vue.js App',
                name: '',
                email: '',
                message: '',
                nameFlag: false,
                emailFlag: false,
                messageFlag: false,
                submitOnce: true
            }
        },
        methods: {
            contactFormSubmit: function (event) {
                event.preventDefault()
                if(!this.name) {
                    this.nameFlag = true
                } else {
                    this.nameFlag = false
                }
                if (!this.email) {
                    this.emailFlag = true
                } else {
                    this.emailFlag = false
                }
                if (!this.message) {
                    this.messageFlag = true
                } else {
                    this.messageFlag = false
                }
                if(this.name && this.email && this.message){
                    this.submitOnce = false
                    let $this = this
                    axios.post('/createcontact', {
                        name: this.name,
                        email: this.email,
                        message: this.message
                    }).then(function (response) {
                        // handle success
                        console.log(response)
                        setTimeout(function () {
                            $this.submitOnce = true
                            Vue.$toast.open(
                                {
                                    message: 'Form submitted successfully!',
                                    type: 'success',
                                    position: 'top-right'
                                    // all other options
                                }
                            )
                        }, 2000)
                    })
                } else {
                    Vue.$toast.open(
                        {
                            message: 'Some fields are missing!',
                            type: 'error',
                            position: 'top-right'
                            // all other options
                        }
                    )
                }
            },
            nameFuntion: function (msg) {
                if (!msg) {
                    this.nameFlag = true
                } else {
                    this.nameFlag = false
                }
            },
            emailFuntion: function (msg) {
                if (!msg) {
                    this.emailFlag = true
                } else {
                    this.emailFlag = false
                }
            },
            messageFuntion: function (msg) {
                if (!msg) {
                    this.messageFlag = true
                } else {
                    this.messageFlag = false
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Contact.vue